import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/Card';
import { Input } from '@/components/ui/Input';
import { Button } from '@/components/ui/Button';

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro desconhecido');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-raios-bg px-4">
      <div className="w-full max-w-sm md:max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img
            src="/raios-mark.png"
            alt="RAIOS"
            className="inline-block w-14 h-14 rounded-2xl mb-4 object-cover"
          />
          <h1 className="text-3xl font-bold text-raios-text tracking-tight">RAIOS</h1>
          <p className="text-raios-muted text-sm mt-1">Sistema Operacional de Inteligencia</p>
        </div>

        {/* Card */}
        <Card className="p-0">
          <CardHeader>
            <CardTitle>Entrar</CardTitle>
          </CardHeader>

          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <Input
                label="Email"
                type="email"
                placeholder="voce@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <Input
                label="Senha"
                type="password"
                placeholder="Sua senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                error={error || undefined}
              />

              {/* DEM-2044: link de recuperação de senha (não altera o fluxo de login). */}
              <div className="flex justify-end -mt-1">
                <Link
                  to="/forgot-password"
                  className="text-sm text-raios-accent hover:underline"
                >
                  Esqueci minha senha
                </Link>
              </div>

              <Button
                type="submit"
                variant="brand"
                className="w-full"
                loading={loading}
                disabled={loading}
              >
                {loading ? 'Processando...' : 'Entrar'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
